<template>
	<div>
		<b-row>
			<b-col>
				<b-breadcrumb>
					Channel demo
				</b-breadcrumb>
			</b-col>
			<b-col sm="auto">
				<b-breadcrumb><a href="#" @click.prevent="showLiveLinks">Show live links</a></b-breadcrumb>
			</b-col>
		</b-row>
		<b-card-group columns>
			<b-card
				:border-variant="channel.status == 'disabled' ? 'secondary' : (channel?.info?.numLive > 0 ? 'success' : 'dark')"
				:header-bg-variant="channel.status == 'disabled' ? 'secondary' : (channel?.info?.numLive > 0 ? 'success' : 'dark')"
				v-for="(channel, i) in channels"
				:key="i"
				no-body
			>
				<b-card-header class="channelHeader" :style="{ backgroundImage: `url('${encodeURI(channel?.info?.bannerImageUrl)}')` }">
					<a href="#" target="_blank" rel="noreferrer" class="float-right text-info" @click.prevent.stop="channel.detailsVisible = !channel.detailsVisible"><b-icon icon="question-circle-fill"></b-icon></a>
					<div class="mt-3 mb-3">
						<a :href="channel?.info?.url" target="_blank" rel="noreferrer" :title="channel?.info?.title||channel?.name"><b-avatar :src="channel?.info?.avatarUrl" class="mr-3 boxglow float-left"></b-avatar></a>
						<a :href="channel?.info?.url" target="_blank" rel="noreferrer" :title="channel?.info?.title||channel?.name" class="glow">{{channel?.info?.title||channel?.name}}</a>
						<br />
						<b-avatar size="1rem" class="mr-2 boxglow" style="margin-left: -1.5rem" :src="channel?.service_icon&&channel?.service_icon.url" :title="channel?.service_name"></b-avatar>
						<div class="float-right">
							<b-badge variant="secondary" v-if="channel?.info && ('numViewers' in channel.info)">{{channel?.info?.numViewers||0}} <b-icon icon="eye"></b-icon></b-badge>
							<b-badge :variant="channel?.info?.numLive ? 'success' : 'secondary'">{{channel?.info?.numLive ? `${channel?.info?.numLive == 1 ? '' : `${channel.info.numLive} `}live` : 'offline'}}</b-badge>
						</div>
						<small v-if="channel?.info && ('numFollowers' in channel?.info)" class="glow">{{channel?.info?.numFollowers||0}} followers</small>
						<span v-if="channel?.info && ('numSubscribers' in channel.info)" class="glow">{{channel?.info?.numSubscribers||0}} subscribers<br /></span>
						<small v-if="channel?.info && ('createdAt' in channel.info)" class="glow"><br />created {{channel?.info?.createdAt}}</small>
					</div>
				</b-card-header>
				<b-alert variant="danger" :show="!!channel.error">{{channel.error}}</b-alert>
				<a :href="channel?.info?.chats?.[0]?.info?.liveUrl" target="_blank">
					<b-aspect aspect="16:9" :style="{ backgroundImage: `url('${encodeURI(channel?.info?.chats?.[0]?.info?.liveThumbnailUrl||channel?.info?.offlineImageUrl||'')}')` }" class="thumbnail mt-1 position-relative">
						<b-badge :variant="channel?.info?.chats?.[0]?.info?.isLive ? 'success' : 'secondary'" class="boxglow">{{channel?.info?.chats?.[0]?.info?.isLive ? `live` : 'offline'}}</b-badge><br />
						<div style="position: absolute; bottom: 12px">
							<b-badge variant="secondary" class="boxglow">{{channel?.info?.chats?.[0]?.info?.liveNumViewers||0}} <b-icon icon="eye"></b-icon></b-badge><br />
						</div>
						<div v-if="!channel?.info?.chats?.[0]?.info?.liveThumbnailUrl&&!channel?.info?.offlineImageUrl" class="text-center text-secondary">
							<br />
							<b-icon font-scale="6" icon="camera-video"></b-icon>
						</div>
					</b-aspect>
				</a>
				<b-card-body v-if="channel?.info?.chats?.[0]?.info">
					<a v-if="channel.info.chats[0].info.liveTitle" :href="channel.info.chats[0].info.liveUrl" target="_blank">{{channel.info.chats[0].info.liveTitle}}</a>
					<i v-else>No title</i>
					<br />
					<b-badge pill>{{channel?.info?.chats?.[0]?.info?.liveCategoryName}}</b-badge>
					<b-badge pill>{{channel?.info?.chats?.[0]?.info?.liveLanguage}}</b-badge>
				</b-card-body>
				<b-table-simple fixed small striped no-header class="mb-0">
					<b-tbody>
						<b-tr v-for="(chat, idx) in channel?.info?.chats?.slice(1)" :key="idx">
							<b-td style="width: 100px">
								<div class="thumbnailWrap">
									<a :href="chat?.info?.liveUrl" target="_blank">
										<img :src="chat?.info?.liveThumbnailUrl||chat?.info?.livePlaceholderUrl" style="max-width: 100%">
									</a>
									<div class="meta">
										<div class="viewers">
											<b-badge variant="secondary" v-if="channel?.info && ('numViewers' in channel.info)" class="boxglow">{{chat?.info?.liveNumViewers||0}} <b-icon icon="eye"></b-icon></b-badge><br />
										</div>
										<!-- <div class="uptime">{{chat?.info?.liveStartTime}}</div> -->
									</div>
								</div>
							</b-td>
							<b-td>
								<a v-if="chat?.info?.liveTitle" :href="chat?.info?.liveUrl" target="_blank">{{chat.info?.liveTitle}}</a>
								<i v-else>No title</i>
								<br />
								{{chat?.info?.liveCategoryName}}
								{{chat?.info?.liveLanguage}}<br />
							</b-td>
						</b-tr>
						<b-tr v-if="!channel?.info?.chats?.length">
							<b-td colspan="2">No chats.</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
				<b-collapse v-if="channel" v-model="channel.detailsVisible">
					<pre>{{channel}}</pre>
				</b-collapse>
			</b-card>
		</b-card-group>
	</div>
</template>

<script>
import util from '../util';

export default {
	name: 'ChannelDemo',
	data() { return {
		channels: [],
		error: null,
		loading: 0,
	}},
	created() {
		this.loadChannels();
	},
	methods: {
		async loadChannels() {
			try {
				this.loading++;
				this.$set(this, 'channels', (await this.$api.get('channels')).filter(c => c.status == 'enabled'));
				for(let i in this.channels) {
					this.$api.get(`channel/${encodeURIComponent(this.channels[i].service_id)}/${encodeURIComponent(this.channels[i].token)}/info/full`).then(info => {
						if(info.createdAt)
							info.createdAt = util.relativeDate(info.createdAt);
						this.$set(this.channels[i], 'info', info);
						this.$set(this.channels[i], 'error', null);
					}, err => {
						this.$set(this.channels[i], 'info', null);
						this.$set(this.channels[i], 'error', err);
					});
				}
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		showLiveLinks() {
			const h = this.$createElement;
			this.$bvModal.msgBoxOk(h('div', {}, [
				h('h3', {}, 'Channels'),
				h('ul', {}, this.channels.filter(c => !!c?.info?.url).map(c => h('li', {}, [ h('a', { domProps: { innerText: c.info.url }, attrs: { href: c.info.url } } ) ]))),
				h('h3', {}, 'Videos'),
				h('ul', {}, this.channels.reduce((accum, c) => accum.concat((c?.info?.chats||[]).filter(ch => ch?.info?.liveUrl && ch?.info?.isLive)), []).map(c => h('li', {}, [ h('a', { domProps: { innerText: c.info.liveUrl }, attrs: { href: c.info.liveUrl } } ) ]))),
			]), { title: 'Your live links' });
		},
	}
};
</script>

<style>
	.boxglow {
		box-shadow: 0 0 10px 5px #241e32;
	}
	.glow {
		text-shadow: 0 0 10px #241e32, 1px 0 10px #241e32, -1px 0 10px #241e32, 0 1px 10px #241e32, 0 -1px 10px #241e32;
	}
	.channelHeader {
		background-size: cover;
		background-position: center;
	}
	.thumbnail {
		background-size: cover;
		padding: 12px;
		position: relative;
	}
	.thumbnailWrap {
		position: relative;
	}
	.meta {
		position: absolute;
		bottom: 0;
		left: 0;
		rigth: 0;
		padding: 2px;
	}
</style>
